import { IColor } from "../../api.js";
import { CustomMaterialWrapper } from "./CustomMaterialWrapper.js";
import { ShaderMaterial as BABYLON_ShaderMaterial } from '@inter-ikea-betrakta-babylonjs/core/Materials/shaderMaterial.js';
import { Constants as BABYLON_Constants } from '@inter-ikea-betrakta-babylonjs/core/Engines/constants.js';
import '../shaders/ghost.vertex.js';
import '../shaders/ghost.fragment.js';
import { Color3ConstantReference } from "./PropertyWrappers.js";
class GhostPrePassMaterialImplementation extends BABYLON_ShaderMaterial {
    constructor(viewer) {
        super('ghost material', viewer.scene, 'ghost', {
            attributes: ['position'],
            uniforms: ['viewProjection', 'color', 'alpha'],
            needAlphaBlending: true,
            needAlphaTesting: true,
            defines: viewer.is_rendering_to_float_framebuffer() ? ['#define ENABLE_VIEWER_TONEMAPPING_IN_POST'] : []
        });
        this.color = new IColor(1, 1, 1);
        this.alphaMode = BABYLON_Constants.ALPHA_COMBINE;
        this.transparencyMode = BABYLON_ShaderMaterial.MATERIAL_ALPHABLEND;
        this.depthFunction = BABYLON_Constants.LEQUAL;
        this.backFaceCulling = false;
        this.needDepthPrePass = true;
        this.alpha = 0.5;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    _afterBind(mesh, effect = null) {
        super._afterBind(mesh, effect);
        effect === null || effect === void 0 ? void 0 : effect.setMatrix('viewProjection', this.getScene().getTransformMatrix());
        effect === null || effect === void 0 ? void 0 : effect.setVector3('color', IColor.to_linear_space(this.color));
        effect === null || effect === void 0 ? void 0 : effect.setFloat('alpha', this.alpha);
    }
}
export class GhostMaterial extends CustomMaterialWrapper {
    constructor(viewer) {
        super("GhostMaterial");
        this.babylon_material = new GhostPrePassMaterialImplementation(viewer);
        this._viewer = viewer;
        this._color = new Color3ConstantReference(this.babylon_material, 'color', () => {
            this._viewer.mark_scene_dirty();
        });
    }
    get alpha() {
        return this.babylon_material.alpha;
    }
    set alpha(alpha) {
        if (alpha !== this.babylon_material.alpha) {
            this.babylon_material.alpha = alpha;
            this._viewer.mark_scene_dirty();
        }
    }
    get color() {
        return this._color;
    }
    set color(color) {
        if (IColor.equals(color, this.babylon_material.color))
            return;
        IColor.copy_to_ref(color, this.babylon_material.color);
        this._viewer.mark_scene_dirty();
    }
    clone() {
        const clone = new GhostMaterial(this._viewer);
        clone.alpha = this.alpha;
        clone.color = this.color;
        return clone;
    }
    dispose() {
        this.babylon_material.dispose();
    }
}
//# sourceMappingURL=GhostMaterial.js.map